module.exports = __webpack_public_path__ + "img/icn_pr.892f2725.svg";